export default __webpack_public_path__ + "static/media/promo-gp-mx.4be0c48f.png";